import api from "@/plugins/api/EntryPoint";

export default {
  getSettings(callBackFn) {
    api.get(`settings/user`, callBackFn);
  },
  storeSettings(settings, callBackFn) {
    return api.post(`settings/update`, settings, callBackFn);
  },
  storePhone(phone) {
    return api.post(`settings/add-phone`, { phone });
  },
  storeIndicationPhone(phone) {
    return api.post(`settings/add-indication-phone`, { phone });
  },
  async getPhone(callBackFn) {
    await api.get(`settings/phone`, callBackFn);
  },
  async getIndicationPhone(uid, callBackFn) {
    await api.get(`settings/get-indication-phone/` + uid, callBackFn);
  },
  putLanguage(language) {
    return api.put("settings/put-language", { language });
  },
  setTheme(theme) {
    return api.put("settings/set-theme", { theme });
  },
  getTheme(callBackFn) {
    return api.get(`settings/theme`, callBackFn);
  },
  getLanguage(callBackFn) {
    return api.get(`settings/language`, callBackFn);
  },
  setShareStatus() {
    return api.put("settings/set-share-status");
  },
  setShareFacebookStatus() {
    return api.put("settings/set-share-facebook-status");
  },
};
